import { render, staticRenderFns } from "./TourPrivate.vue?vue&type=template&id=51966dcb"
import script from "./TourPrivate.vue?vue&type=script&lang=js"
export * from "./TourPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51966dcb')) {
      api.createRecord('51966dcb', component.options)
    } else {
      api.reload('51966dcb', component.options)
    }
    module.hot.accept("./TourPrivate.vue?vue&type=template&id=51966dcb", function () {
      api.rerender('51966dcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/TourPrivate.vue"
export default component.exports